const DEFAULT_LOCALE = "de-DE"
const DEFAULT_TIME_ZONE = "UTC"
const DEFAULT_MONAT_JAHR_SEPARATOR = "/"
const DEFAULT_SYMBOL_SPACING = "\u202F" // Narrow no-break space
const DEFAULT_DATUM_SPACING = "\u202F" // Narrow no-break space
const DEFAULT_DEZIMALZAHL_PRECISION = 2
const DEFAULT_WAEHRUNG_PRECISION = 0
const DEFAULT_PROZENT_PRECISION = 2
const MONAT_JAHR_FORMATTER = new Intl.DateTimeFormat(DEFAULT_LOCALE, {
	month: "2-digit",
	year: "numeric",
	timeZone: DEFAULT_TIME_ZONE,
})

export function formatMonatJahr(utcMs) {
	if (!utcMs) return ""

	const parts = MONAT_JAHR_FORMATTER.formatToParts(new Date(utcMs))
	const monat = parts.find((part) => part.type === "month")?.value || "00"
	const jahr = parts.find((part) => part.type === "year")?.value || "0000"

	return `${monat}${DEFAULT_DATUM_SPACING}${DEFAULT_MONAT_JAHR_SEPARATOR}${DEFAULT_DATUM_SPACING}${jahr}`
}

export function formatDezimalzahl(wert) {
	return new Intl.NumberFormat(DEFAULT_LOCALE, {
		minimumFractionDigits: DEFAULT_DEZIMALZAHL_PRECISION,
		maximumFractionDigits: DEFAULT_DEZIMALZAHL_PRECISION,
	}).format(Number(wert || 0))
}

export function formatWaehrung(wert) {
	const zahl = new Intl.NumberFormat(DEFAULT_LOCALE, {
		minimumFractionDigits: DEFAULT_WAEHRUNG_PRECISION,
		maximumFractionDigits: DEFAULT_WAEHRUNG_PRECISION,
	}).format(Number(wert || 0))

	return `${zahl}${DEFAULT_SYMBOL_SPACING}€`
}

export function formatProzent(wert) {
	const zahl = new Intl.NumberFormat(DEFAULT_LOCALE, {
		minimumFractionDigits: DEFAULT_PROZENT_PRECISION,
		maximumFractionDigits: DEFAULT_PROZENT_PRECISION,
	}).format(Number(wert || 0))

	return `${zahl}${DEFAULT_SYMBOL_SPACING}%`
}
